import {
  IRouterMiddleware,
  MiddlewareRoute,
  MiddlewareCallback
} from '../middleware.interface';

// TODO REMOVE WHEN FLAG IS REMOVED flagKeys.coinRevenueOverview
export class HandleSellCoinsRedirect implements IRouterMiddleware {
  canActivate(to: MiddlewareRoute): boolean {
    return to.path === '/sell-coins';
  }

  async execute(
    to: MiddlewareRoute,
    from: MiddlewareRoute,
    next: MiddlewareCallback
  ): Promise<void> {
    if (to.meta.hideFromMenu()) {
      return next('/overview-sell-coins');
    }
  }
}
